import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Row, Tabs, message, Badge } from 'antd';
import ProForm, { ProFormInstance } from '@ant-design/pro-form';
import { FileUploadUtility, WdiFileList } from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import { FormPageProps, WdiFormPageTitle } from '@/components/WdiBus/FormPage';
import { ResponseStatus } from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import { DataOptions } from '@/services/basic/metadata';
import { Enum } from '@/enums/system';
import DynamicInformation from './DynamicInformation';
import { WdiInput, WdiStaffCard, WdiTextArea } from '@/components/WdiControls';
import { OninvoicePaymentDetailsForApprovalPanel } from '../../OninvoicePaymentApply/components/detail';
import { ViewEntityProps, initApprovalPageContext } from '../../OninvoicePaymentApply/components/data';

const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/activityapi/spButtons/get",
      keys: [
        // "UndoButton",
        // "ReeditButton",
        // "CancelButton",
        "InterveneFlowButton",
        // "ExportLockRemoveButton",
        // "ModifyPrepayButton",
        // "ModifyInvoiceNoButton",
        // "TbdButton",
        // "CancelTbdButton"
      ]
    }
  ],
  errorParams: [
    {
      url: "/activityapi/spButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

const approvalConfig: any = {
  params: {
    url: "/activityapi/spButtons/get",
    keys: [
      "ApprovalButton"
    ]
  }
};

const OninvoicePaymentApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        if (viewEntity.formSp) {
          formRef.current?.setFieldsValue({
            amountExVat: viewEntity.formSp.amountExVat,
            remark: viewEntity.formSp.remark,
            attachment: FileUploadUtility.parse(viewEntity.formSp.fileName, viewEntity.formSp.filePath)
          });
        }


        if (viewEntity.formSpDetails) {
          setDataSource(DataStore.init(viewEntity.formSpDetails));
        }


        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `on-invoice合同返利付款单【${entity.form?.formNo}】`;
      DataOptions.search({ typeGroup: 3, value: entity.form?.statusId }).then(response => {
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (response.data && response.data.length > 0) {
          if (entity.form?.statusId != Enum.FormStatus.SCRAP && entity.form?.exportStatus == Enum.ExportStatus.EXPORT_SUCCESS) {
            title += `，已导出`;
          } else {
            title += `，${response.data[0].name}`;
          }
          if (props.setPageTitle) props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={entity?.form}
              useCaseId={Enum.UseCase.RSP}
              moreConfig={moreConfig}
              approvalConfig={approvalConfig} />
          );
        }
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId} />
      <Tabs defaultActiveKey="1" size="large">
        <TabPane tab={<span>付款信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => { return (<></>) },
            }}
          >
            <Row gutter={[16, 24]}>
              <Col className="gutter-row" span={4}>
                <Form.Item name="amountExVat" label="本次付款总金额" >
                  <WdiInput readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 24]}>
              <Col className="gutter-row" span={16}>
                <Form.Item name="remark" label="付款备注" >
                  <WdiTextArea rows={4} readOnly />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  name="attachment"
                  label="付款附件"
                  valuePropName='fileList'
                  getValueFromEvent={(e: any) => { return e.fileList || []; }}
                >
                  <WdiFileList />
                </Form.Item>
              </Col>
            </Row>
          </ProForm>
          <OninvoicePaymentDetailsForApprovalPanel dataSource={dataSource} />
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="2">
          <DynamicInformation formId={entity?.form?.formId} formTypeId={entity?.form?.formTypeId} pageTypeId={entity?.form?.pageTypeId} useCaseId={Enum.UseCase.RSP} />
        </TabPane>
      </Tabs>

    </>
  );
};
export default OninvoicePaymentApprovalApp;
